import { AccountType } from '@/common/types'
import { APP_ROUTES } from '@/common/constants'

export const TAB_KEYS = ['settings', 'account', 'holders'] as const
export type AccountTabKey = (typeof TAB_KEYS)[number]

export const TAB_TO_ROUTE: Record<AccountTabKey, string> = {
    account: APP_ROUTES.ACCOUNT_DETAILS,
    settings: APP_ROUTES.ACCOUNT_SETTINGS,
    holders: APP_ROUTES.ACCOUNT_HOLDERS,
}

export function getAvailableTabs(accountType?: AccountType): AccountTabKey[] {
    if (accountType === AccountType.ADVISER) {
        return ['settings', 'account']
    }
    return Array.from(TAB_KEYS)
}
